module.exports = __webpack_public_path__ + "static/media/favicon.6ddc8a0b.ico";